// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"57ade5af","703":"3bd21531","921":"a4d5fcbb"}[chunkId] + ".chunk.js";
};